import { httpPost, urlConcat } from '@/utils/http'
import {API_ORDER} from '@/config'

export async function getUserInfo(authToken) {
  let token = authToken;
  let data = { hasLicense: false, };

  if (token) {
    let userInfo = await httpPost(urlConcat(API_ORDER, '/api/order/GetUserInfo'), { token });
    if (userInfo) data.hasLicense = userInfo.HasLicens || userInfo.HasLicense;
  }

  return data;
}
